import { AmoregIcon } from "./Icons";

/** Keeps the router visible while initial session reads or route loads are pending. */
export function AppLoadingSurface() {
  return (
    <main className="flex min-h-svh min-w-0 w-full flex-1 items-center justify-center bg-background p-6 text-foreground">
      <div
        className="flex flex-col items-center gap-4 text-center"
        role="status"
        aria-live="polite"
      >
        <AmoregIcon aria-hidden="true" className="size-16" />
        <p className="text-sm text-muted-foreground">Loading your workspace…</p>
      </div>
    </main>
  );
}
